<script>
import simplebar from "simplebar-vue";
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Chat",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, simplebar },
  data() {
    return {
      title: "Chat",
      items: [
        { text: "Home", href: "/" },
        { text: "Chat", active: true },
      ],
      submitted: false,
      form: { message: "" },
      username: "-",
      student_id: "",
      userData: JSON.parse(localStorage.getItem("user")),
      chats: [],
      usermessages: [],
      chatMessagesData: [],
    };
  },
  validations: {
    form: { message: { required } },
  },
  methods: {
    async fetchChats() {
      let url = "/fetchchats";
      await axios.get(url).then((response) => {
        if (response.status == 200) {
          this.chats = response.data.chats;
        }
      });
    },
    async fetchMessages(student_id) {
      let url = `/fetchmessages/${student_id}`;
      await axios.get(url).then((response) => {
        this.usermessages = response.data.messages;
        this.usermessages.forEach((msg) => {
          if (msg.addedby == "User") {
            this.chatMessagesData.push({
              id: msg.id,
              align: "left",
              name: msg.student.first_name,
              message: msg.message,
              time: msg.addedon,
            });
          } else {
            this.chatMessagesData.push({
              id: msg.id,
              align: "right",
              name: msg.addedby.username,
              message: msg.message,
              time: msg.addedon,
            });
          }
        });
        this.handleScroll();
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    chatUsername(fname, lname, student_id) {
      this.username = fname + " " + lname;
      this.student_id = student_id;
      this.chatMessagesData = [];
      this.fetchMessages(student_id);
    },

    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    async formSubmit(e) {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const message = this.form.message;
        const student_id = this.student_id;

        let formData = new FormData();
        formData.append("message", message);
        formData.append("student", student_id);
        let url = "/repymessage";
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchMessages(student_id);
            this.form.message = "";
          }
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.form = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
  },
  mounted() {
    this.fetchChats();
    var container1 = document.querySelector(
      "#chat-list .simplebar-content-wrapper",
    );
    container1.scrollTo({ top: 500, behavior: "smooth" });

    var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper",
    );
    container2.scrollTo({ top: 500, behavior: "smooth" });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-lg-flex" v-if="userData.permissions['others'] == 1">
      <div class="chat-leftsidebar me-lg-4">
        <div class="chat-leftsidebar-nav">
          <div>
            <simplebar style="max-height: 410px" id="chat-list">
              <ul class="list-unstyled chat-list">
                <li
                  class
                  v-for="data of chats"
                  :key="data.id"
                  @click="
                    chatUsername(
                      data.first_name,
                      data.last_name,
                      data.student_id,
                    )
                  "
                  :class="{ active: username == data.student_id }"
                >
                  <a href="javascript: void(0);">
                    <div class="media">
                      <div class="align-self-center me-3">
                        <i
                          :class="`mdi mdi-circle text-success font-size-10`"
                        ></i>
                      </div>
                      <div
                        class="align-self-center me-3"
                        v-if="data.student_photo"
                      >
                        <img
                          :src="getFiles(data.student_photo)"
                          class="rounded-circle avatar-xs"
                          alt
                        />
                      </div>
                      <div
                        class="avatar-xs align-self-center me-3"
                        v-if="!data.student_photo"
                      >
                        <span
                          class="avatar-title rounded-circle bg-soft bg-primary text-primary"
                          >{{ data.first_name.charAt(0) }}</span
                        >
                      </div>
                      <div class="media-body overflow-hidden">
                        <h5 class="text-truncate font-size-14 mb-1">
                          {{ data.first_name }} {{ data.last_name }}
                        </h5>
                        <i class="text-success h6">{{ data.student_id }}</i>
                      </div>
                      <div class="font-size-11">{{ data.time }}</div>
                    </div>
                  </a>
                </li>
              </ul>
            </simplebar>
          </div>
        </div>
      </div>
      <div class="w-100 user-chat">
        <div class="card shadow-lg">
          <div class="ps-3 py-3 border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-1" v-if="username == '-'">
                  {{ userData.school }}
                </h5>
                <h5 class="font-size-15 mb-1" v-else>{{ username }}</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Active now
                </p>
              </div>
            </div>
          </div>
          <div class="chat-users">
            <div class="chat-conversation p-3">
              <simplebar
                style="max-height: 400px"
                id="containerElement"
                ref="current"
              >
                <ul class="list-unstyled">
                  <li
                    v-for="data of chatMessagesData"
                    :key="data.message"
                    :class="{ right: `${data.align}` === 'right' }"
                  >
                    <div class="conversation-list">
                      <b-dropdown
                        variant="white"
                        menu-class="dropdown-menu-end"
                      >
                        <template v-slot:button-content>
                          <i class="bx bx-dots-vertical-rounded"></i>
                        </template>
                        <b-dropdown-item>Copy</b-dropdown-item>
                        <b-dropdown-item>Delete</b-dropdown-item>
                      </b-dropdown>
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <p>{{ data.message }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i
                          >{{ data.time }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                      type="text"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                      placeholder="Enter Message..."
                      :class="{
                        'is-invalid': submitted && $v.form.message.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.message.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.message.required"
                        >This value is required.</span
                      >
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Images"
                            ><i class="mdi mdi-file-image-outline"></i
                          ></a>
                        </li>
                        <li class="list-inline-item">
                          <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Add Files"
                            ><i class="mdi mdi-file-document-outline"></i
                          ></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto" v-if="username != '-'">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md"
                  >
                    <span class="d-none d-sm-inline-block me-2">Send</span
                    ><i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to view this Page.</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
